import React, { Component } from "react";
import styled from "styled-components";

import { Popover } from "@material-ui/core";

import {
    PictureAsPdf as PictureAsPdfIcon,
    OpenInNew as OpenInNewIcon,
    Edit as EditIcon,
    List as ListIcon,
    Link as LinkIcon
} from "@material-ui/icons";

import { FlexBox } from "js/react/components/LayoutGrid";
import { ClipboardType, clipboardWrite } from "js/core/utilities/clipboard";

export const PresentationActionsContainer = styled.div`
  background: white;
  display: grid;
  grid-auto-flow: row;
  gap: 0px;
  align-items: flex-start;
  justify-content: center;
  width: 300px;
`;

export const PresentationAction = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  color: #444;
  cursor: pointer;
  user-select: none;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0px;
  padding: 15px 20px;

  svg {
    fill: #444;
    margin-right: 10px;
    font-size: 24px;
  }

  label {
    font-size: 18px;
    font-weight: 600;
    color: #222;
    margin-bottom: 5px;
  }

  span {
    font-size: 14px;
    color: #777;
  }

  &: hover {
    background: #E8F7FD;
  }
`;

function PresentationActions({
    onAction,
    onDownloadPdf,
    allowCopyLink,
    onCopyDeck,
    onEditPresentation,
    onSwitchPresentation
}) {
    return (
        <PresentationActionsContainer>
            {allowCopyLink &&
                <PresentationAction onClick={() => onAction("copy-link")}>
                    <LinkIcon />
                    <FlexBox vertical left>
                        <label>Copy Link</label>
                        <span>Copy a link to this presentation to your clipboard</span>
                    </FlexBox>
                </PresentationAction>
            }
            {onDownloadPdf &&
                <PresentationAction onClick={() => onAction("download-pdf")}>
                    <PictureAsPdfIcon />
                    <FlexBox vertical left>
                        <label>Download as PDF</label>
                        <span>Save a PDF version of this presentation</span>
                    </FlexBox>
                </PresentationAction>
            }
            {onCopyDeck &&
                <PresentationAction onClick={() => onAction("copy-deck")}>
                    <OpenInNewIcon />
                    <FlexBox vertical left>
                        <label>Copy Presentation</label>
                        <span>Copy this presentation into your own Beautifiul.ai account</span>
                    </FlexBox>
                </PresentationAction>
            }
            {onEditPresentation &&
                <PresentationAction onClick={() => onAction("edit-presentation")}>
                    <EditIcon />
                    <FlexBox vertical left>
                        <label>Edit Presentation</label>
                        <span>Open this presentation in Beautiful.ai</span>
                    </FlexBox>
                </PresentationAction>
            }
            {onSwitchPresentation &&
                <PresentationAction onClick={() => onAction("switch-presentation")}>
                    <ListIcon />
                    <FlexBox vertical left>
                        <label>Switch Presentation</label>
                        <span>Select another presentation to replace this one with</span>
                    </FlexBox>
                </PresentationAction>
            }
        </PresentationActionsContainer>
    );
}

class PresentationActionsMenu extends Component {
    handleAction = action => {
        const {
            onClose,
            onEditPresentation,
            currentSlideIndex,
            onDownloadPdf,
            onSwitchPresentation,
            onCopyDeck,
            username,
        } = this.props;

        switch (action) {
            case "copy-link":
                clipboardWrite({
                    [ClipboardType.TEXT]: window.location.href,
                });
                break;
            case "copy-deck":
                onCopyDeck();
                break;
            case "edit-presentation":
                onEditPresentation(currentSlideIndex ?? 0);
                break;
            case "download-pdf":
                onDownloadPdf(username);
                break;
            case "switch-presentation":
                onSwitchPresentation();
                break;
        }

        onClose();
    }

    render() {
        const { isOpen, onClose, anchorEl } = this.props;

        return (
            <Popover
                open={isOpen}
                anchorEl={anchorEl}
                disableEnforceFocus
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "center"
                }}
                transformOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                }}
                style={{ zIndex: 999999 }}
                onClose={onClose}
            >
                <PresentationActions {...this.props} onAction={this.handleAction} />
            </Popover>
        );
    }
}

export default PresentationActionsMenu;
